import BaseApiServiceV2 from "./BaseApiServiceV2";

class ListingsService extends BaseApiServiceV2 {
  /**
   * @param {String} id
   * @returns Promise<Object>
   * @memberof SearchService
   */

  getListingDetailsByID(id: string) {
    return this.apiGet(`/listing/${id}`);
  }
  fetchPropertyListings(id: string) {
    return this.apiGet(`/property/property-listings/${id}`);
  }
  getMetadataListingsByProperty(id: string) {
    return this.apiGet(
      `/listing/metadata/properties/${id}/listings`
    );
  }
  getNearByOffices(
    latitude: number,
    longitude: number,
    recordsLimit: number = 10,
    noOfWS: number,
    spaceTypeFormula: string = '',
    radius: string = '13'
  ) {
    return this.apiGet(
      `/listing/nearby?latitude=${latitude}&longitude=${longitude}&radius=${radius}&recordsLimit=${recordsLimit}&noOfWS=${noOfWS}&spaceTypeFormula=${spaceTypeFormula}`
    );
  }
  getOfficesAround(suburb: string, sfid: string, latitude: number, longitude: number, limit: number, spaceType?: string, country?: string) {
    return this.apiGet(`/area/area-office-types/nearby?sfid=${sfid}&latitude=${latitude}&longitude=${longitude}&radius=30&limit=${limit}&spaceType=${spaceType || null}&country=${country || null}`);
  }
  getPopularSearches(latitude: number, longitude: number, suburb: string, spaceType: string, recordsLimit: number) {
    return this.apiGet(
      `/area/nearby/${suburb}?&suburb=${suburb}&latitude=${latitude}&spaceType=${spaceType}&longitude=${longitude}&radius=10&limit=${recordsLimit}`
    );
  }
  getListingsByBuildingId(id: string, sortOrder: string = 'asc') {
    return this.apiGet(`/listing/by-building-id/?id=${id}&sortOrder=${sortOrder}`);
  }
  getCompareListings(ids: string, isMobile: boolean) {
    return this.apiGet(
      `/listing/compare/listings?ids=${ids}&isMobile=${isMobile}`
    );
  }
  getAvailableListingsCount(path: string) {
    return this.apiGet(`/listing/metadata/available-listings-count-by-people?${path}`)
  }

  sendSuccessNotification(data, type) {
    return this.apiPost(`/email?type=${type}`, data);
  }

  sendErrorNotification(data, type) {
    return this.apiPost(`/email/fallback?type=${type}`, data);
  }
}
export default new ListingsService();
